export const Svg_118 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M30.334 64.167V48.125h-8.75L29.02 24.21c.39-1.215 1.118-2.151 2.188-2.808a6.567 6.567 0 0 1 3.5-.984c1.264 0 2.43.328 3.5.984 1.07.657 1.798 1.593 2.187 2.808l7.438 23.916h-8.75v16.042h-8.75Zm4.38-47.687c-1.462 0-2.715-.521-3.76-1.562-1.046-1.042-1.568-2.293-1.568-3.755 0-1.463.52-2.716 1.562-3.762 1.041-1.045 2.293-1.567 3.755-1.567 1.462 0 2.716.52 3.76 1.562 1.046 1.04 1.569 2.293 1.569 3.755 0 1.462-.521 2.716-1.562 3.76-1.041 1.046-2.293 1.569-3.755 1.569Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={27.654}
        x2={57.142}
        y1={14.584}
        y2={36.059}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)